import { message, Modal } from "antd";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { postData, putData } from "../../../../actions/developer";
import { useParams } from "react-router-dom";
import { decryptData, encryptData } from "../../../../actions/crypto";
import { getData } from "../../../../actions/apiCall";

const TabChangeDetection = ({ children }) => {
    const [tabSwitchCount, setTabSwitchCount] = useState(0);
    const { id } = useParams();
    const dispatch = useDispatch();


    const handleConfig = () => {
        setTabSwitchCount((prev) => prev + 1);
        const data = encryptData({ field: 'tabChanged' });
        const resData = dispatch(putData(`/accel-test/update/cheating/config/${id}`, { data }), false);
        if (resData) {
            getConfig()
        }
    }

    useEffect(() => {
        getConfig()
    }, []);


    const getConfig = async () => {
        try {
            const resData = await dispatch(getData(`/accel-test/fetch/cheating/config/${id}`));
            if (resData.code == 200) {
                const config = decryptData(resData.data);
                if (config) {
                    const { tabChanged } = config;
                    if (tabChanged) {
                        setTabSwitchCount(tabChanged);
                    }
                }
            } else {
                message.error("Failed to fetch configuration.");
            }
        } catch (error) {
            console.error("Error fetching configuration:", error);
            message.error("Failed to fetch configuration.");
        }
    };


    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {

                const modal = Modal.warning({
                    title: "Warning!",
                    content: "You switched tabs! This may be considered cheating.",
                    onOk: () => {
                        modal.destroy();
                    }
                });
                setTimeout(() => {
                    modal.destroy();
                }, 5000); // Auto close after 5 seconds
                handleConfig()
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        if (tabSwitchCount >= 3) {
            Modal.warning({
                title: "Warning!",
                content: "Cheating detected! You have switched tabs multiple times. Your exam exam is submitting automatically.",
                cancelButtonProps: {
                    style: { display: "none" } // Hide the cancel button
                },
                okText: "Submit",
                okButtonProps: {
                    loading: true,
                },
            });
            handleSubmitTest();
        }
    }, [tabSwitchCount]);

    const handleSubmitTest = async () => {
        try {
            const log = "Tab switch detected. more than 3 times.";
            const resData = await dispatch(postData(`/accel-test/faild/test/submit/${id}`, { data: encryptData({ log }) }));
            if (resData.code == 200) {
                message.success("Test submitted successfully.");
            } else {
                message.error("Failed to submit the test.");
            }
        } catch (error) {
            console.error("Error submitting test:", error);
            message.error("Failed to submit the test.");
        } finally {
            location.href = `/instructions/${id}`;
        }
    }

    return children;
}

export default TabChangeDetection;